import { render, staticRenderFns } from "./rolesSettings.vue?vue&type=template&id=e839e010&scoped=true"
import script from "./rolesSettings.vue?vue&type=script&lang=js"
export * from "./rolesSettings.vue?vue&type=script&lang=js"
import style0 from "./rolesSettings.vue?vue&type=style&index=0&id=e839e010&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e839e010",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e839e010')) {
      api.createRecord('e839e010', component.options)
    } else {
      api.reload('e839e010', component.options)
    }
    module.hot.accept("./rolesSettings.vue?vue&type=template&id=e839e010&scoped=true", function () {
      api.rerender('e839e010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemManagement/rolesSettings/rolesSettings.vue"
export default component.exports